import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_BASE_URL } from "../config";
const userInfo = localStorage.getItem("userInfo");

export const initialState = {
  batches: {
    validatedBatchesForStaffs: [],
    validatedBatchesForExistingParent: [],
    validatedBatchesForNewParent: [],
  },
  status: "idle",
  error: null,
  loading: false,
  success: false,
};

export const fetchBatches = createAsyncThunk(
  "admissionInfo/fetchBatches",
  async (_, { rejectWithValue }) => {
    try {
      console.log("I am here 1");
      console.log(
        "path",
        `${API_BASE_URL}/api/MaximumApplicantsPerBatchInWindow/active`
      );
      const response = await fetch(
        `${API_BASE_URL}/api/MaximumApplicantsPerBatchInWindow/active`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
        }
      );

      console.log("I am here 2", response);
      if (response.status === 404) {
        const errorText = await response.text();
        console.error("No admission window found.", response.status, errorText);
        throw new Error(errorText);
      } else if (!response.ok) {
        const errorText = await response.text();
        console.error(
          "Failed to fetch batches. Status:",
          response.status,
          "Error:",
          errorText
        );
        throw new Error(errorText || `HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
        console.log("action.data: ", data);

      if (!Array.isArray(data)) {
        throw new Error("Expected data to be an array");
      }

      const validatedBatchesForExistingParent = [];
      const validatedBatchesForStaffs = [];
      const validatedBatchesForNewParent = [];

      for (const admissionWindow of data) {
        const admissionWindowId = admissionWindow.admissionWindowId;
        const openFor = admissionWindow.openFor;
        const batches = admissionWindow.batches || [];

        for (const batch of batches) {
          const validatedBatch = {
            admissionWindowId: admissionWindowId,
            batchId: batch.batchID || "unknown",
            batchName: batch.batchName || "Unknown Batch",
            schoolName:
              batch.school?.schoolName || batch.schoolName || "Unknown School",
          };
          if (openFor === 0 || openFor === 3) {
            validatedBatchesForNewParent.push(validatedBatch);
          }
          if (openFor === 1 || openFor === 3) {
            validatedBatchesForExistingParent.push(validatedBatch);
          }
          if (openFor === 2 || openFor === 3) {
            validatedBatchesForStaffs.push(validatedBatch);
          }
        }
      }

      return {
        validatedBatchesForExistingParent,
        validatedBatchesForNewParent,
        validatedBatchesForStaffs,
      };
    } catch (error) {
      console.error("Comprehensive error in fetchBatches:", {
        name: error.name,
        message: error.message,
        stack: error.stack,
      });
      return rejectWithValue(error.message || "Failed to fetch batches");
    }
  }
);

const AdmissionInformationPageSlice = createSlice({
  name: "admissionInformation",
  initialState,
  reducers: {
    clearError(state) {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBatches.pending, (state) => {
        console.log("action.pending: ");
        state.status = "loading";
        state.loading = true;
      })
      .addCase(fetchBatches.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.loading = false;
       console.log("action.payload: ", action.payload);
        state.batches.validatedBatchesForExistingParent =
          action.payload.validatedBatchesForExistingParent;

        state.batches.validatedBatchesForNewParent =
          action.payload.validatedBatchesForNewParent;

        state.batches.validatedBatchesForStaffs =
          action.payload.validatedBatchesForStaffs;
      })
      .addCase(fetchBatches.rejected, (state, action) => {
        state.loading = false;
        state.status = "failed";
        state.error = action.payload;
      });
  },
});

export const { clearError } = AdmissionInformationPageSlice.actions;

export default AdmissionInformationPageSlice.reducer;
